// frontend/packages/business-console/src/services/aiOverageService.js
//
// Thin wrapper over the tenant AI-overage opt-in endpoints
// (/api/v2/business/billing/overage). Business context comes from the
// x-business-id header (axios interceptor). Display-safe: no Stripe ids.

import { api } from '@upryzze/services';

/**
 * @returns {Promise<{
 *   available: boolean,        // feature live (flag + price configured)
 *   optedIn: boolean,
 *   includedUsd: number,
 *   chargeIncrementUsd: number,
 *   reportedUsd: number,
 * }>}
 */
export async function getOverageStatus() {
  const { data } = await api.get('/v2/business/billing/overage');
  return data;
}

export async function optInOverage() {
  const { data } = await api.post('/v2/business/billing/overage/opt-in');
  return data;
}

export async function optOutOverage() {
  const { data } = await api.post('/v2/business/billing/overage/opt-out');
  return data;
}
